import { PaginationTokens } from '../../../../cross-cutting-concerns/state-management/interfaces/StateManagement.types';
import { Machine, MachineListAvailableFilters } from '../../interfaces/Machine.types';
import {
  FilterLastActivityAt,
  MachineConnectionStatus,
  Maybe,
  SortOrders,
} from 'app/cross-cutting-concerns/communication/interfaces/am-api-graphql';
import { IState } from 'app/cross-cutting-concerns/state-management/interfaces/IState';
import { Optional } from 'lib/types/Optional';

export const selectData = (state: IState): Optional<Machine[]> => state.modules['machine-inventory']['robot-list'].data;

export const selectTotalCount = (state: IState): Optional<number> =>
  state.modules['machine-inventory']['robot-list'].totalCount;

export const selectIsLoading = (state: IState): Optional<boolean> =>
  state.modules['machine-inventory']['robot-list'].isLoading;

export const selectPaginationTokens = (state: IState): PaginationTokens =>
  state.modules['machine-inventory']['robot-list'].paginationTokens;

export const selectPage = (state: IState): number => state.modules['machine-inventory']['robot-list'].page;

export const selectPageSize = (state: IState): number => state.modules['machine-inventory']['robot-list'].pageSize;

export const selectFilters = (state: IState): Optional<MachineListAvailableFilters> =>
  state.modules['machine-inventory']['robot-list'].filters.available;

export const selectAreFiltersLoading = (state: IState): boolean =>
  state.modules['machine-inventory']['robot-list'].filters.isLoading;

export const selectActiveMaterialNumberFilter = (state: IState): Optional<string> =>
  state.modules['machine-inventory']['robot-list'].filters.active.materialNumber || undefined;

export const selectActiveSiteFilter = (state: IState): Optional<string> =>
  state.modules['machine-inventory']['robot-list'].filters.active.site || undefined;

export const selectActiveMachineTypeFilter = (state: IState): Optional<string> =>
  state.modules['machine-inventory']['robot-list'].filters.active.machineType || undefined;

export const selectActiveLastActivityAtFilter = (state: IState): Optional<FilterLastActivityAt> =>
  state.modules['machine-inventory']['robot-list'].filters.active.lastActivityAt || undefined;

export const selectActiveConnectionStatusesFilter = (state: IState): Optional<MachineConnectionStatus[]> =>
  state.modules['machine-inventory']['robot-list'].filters.active.connectionStatuses || undefined;

export const selectActiveSearchTextFilter = (state: IState): Optional<string> =>
  state.modules['machine-inventory']['robot-list'].filters.active.searchText || undefined;

export const selectSortField = (state: IState): Maybe<string> =>
  state.modules['machine-inventory']['robot-list'].sortOptions.field;

export const selectSortOrder = (state: IState): Maybe<SortOrders> =>
  state.modules['machine-inventory']['robot-list'].sortOptions.order;

export const selectMapMachines = (state: IState): Optional<Machine[]> =>
  state.modules['machine-inventory']['robot-list'].map.data;

export const selectIsMapLoading = (state: IState): Optional<boolean> =>
  state.modules['machine-inventory']['robot-list'].map.isLoading;

export const selectExportRequestId = (state: IState): Optional<string> =>
  state.modules['machine-inventory']['robot-list'].export.requestId;

export const selectExportDownloadUrl = (state: IState): Optional<string> =>
  state.modules['machine-inventory']['robot-list'].export.downloadUrl;

export const selectExportIsLoading = (state: IState): Optional<boolean> =>
  state.modules['machine-inventory']['robot-list'].export.isLoading;
